// extracted by mini-css-extract-plugin
export default {"wait-payment-activation-template":"styles_wait-payment-activation-template__epafi"};